import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@dnb/eufemia/components';
import { bank_medium } from '@dnb/eufemia/icons';
import { translationKeys } from '@pm-netbank/translations';
import ApplicationRequirementItem from '../../ApplicationRequirementItem/ApplicationRequirementItem';

const UsageRequirementItem = () => {
  return (
    <ApplicationRequirementItem
      title={
        <FormattedMessage
          id={
            translationKeys.becomeCustomer
              .become_customer_start_application_usage_title
          }
        />
      }
      message={
        <FormattedMessage
          id={
            translationKeys.becomeCustomer
              .become_customer_start_application_usage_message
          }
        />
      }
      icon={<Icon icon={bank_medium} />}
    />
  );
};

export default UsageRequirementItem;
